<template>
  <div class="background_team">
    <div class="team_index_text">
      <p style="font-size: 24px" class="animate__fadeInUp animate__animated">Our Team</p>
      <p style="font-size: 36px; margin-bottom: 0;" class="animate__fadeInUp animate__animated animate__delay-1s">Comprehensive analysis and insights lie </p>
      <p style="font-size: 36px" class="animate__fadeInUp animate__animated animate__delay-1s">at the heart of our investment process.</p>
      <p style="margin-bottom: 0; font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">Based on years of in-depth assessments of numerous companies in different
        industries,</p>
      <p style="margin-bottom: 0; font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">we are willing to provide our portfolio companies with great assistance to accelerate post-investment
        performance.</p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">SIG is dedicated to helping our entrepreneurs build successful companies by providing them with capital,
        guidance, network and the best resources available.</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Team_index_en",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.team_index_text {
  padding-top: 30vh;
  text-align: left;
  margin-left: 12vw;
}

.background_team {
  background-image: url("../../../assets/background/index_team.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}


</style>